function homeSatiation() {
    'use strict';

    const $homeSatiation = $('#home-satiation');
    const $children = $homeSatiation.find('.children');

    if ($children.data('count') > 1) {

        /**
         * Home-satiation hover selected effect
         *
         */
        if (window.width >= window.global.bpIPadMin) {
            $homeSatiation.connector({
                connector: '.child',
                removeSiblings: true,
                triggerType: 'mouseover',
                toggleClassName: 'hover',
                atLeastOneEnabled: true,
                breakpoint: true,
                page: window.page.home
            });
        }

        if (window.width < window.global.bpIPadMin) {
            $children.flickity({
                cellAlign: 'left',
                contain: true,
                pageDots: false,
                prevNextButtons: false,
            });

            $($homeSatiation).find('.slider-previous').on('click', function () {
                $children.flickity('previous', true);
            });

            $($homeSatiation).find('.slider-next').on('click', function () {
                $children.flickity('next', true);
            });

        }

    }
}

export default homeSatiation;
